import { Injectable } from '@angular/core';
import {
  Router,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  NavigationExtras
} from '@angular/router';
import { TdLoadingService } from '@covalent/core';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../services/auth.service';

@Injectable()
export class AdminAuthGuard implements CanActivate, CanActivateChild {
  /**
   * Constructor
   *
   * @param _router
   * @param _loadingService
   * @param _authService
   */
  constructor(
    private _router: Router,
    private _loadingService: TdLoadingService,
    private _authService: AuthService
  ) {}

  /**
   *
   * @param route
   * @param state
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.checkLogin(state.url);
  }

  /**
   *
   * @param route
   * @param state
   */
  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.canActivate(route, state);
  }

  /**
   *
   * @param url
   */
  async checkLogin(url: string) {
    const logged = await this._authService.issLoggedInPrivate().toPromise();
    const ssoUrl = environment.ssoUrl
    if (!logged) {
      document.location.href = `${ssoUrl}/private/auth/login?redirectUrl=${document.location.href}`;
      return false;
    }
    const localStorageClientId = localStorage.getItem('clientId');
    if (!localStorageClientId) return true;
    if (
      !logged.clients ||
      !logged.clients[localStorageClientId] ||
      !logged.clients[localStorageClientId].applications ||
      !logged.clients[localStorageClientId].applications['PT']
    ) {
      document.location.href = `${ssoUrl}/private/access-denied`;
      return false;
    }
    // this._authService.redirectUrl = url;
    return true;
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/admin/guards/admin-auth.guard.ts